import React from "react";
import { range } from "../../lib/utils";
import { MAX_MISTAKES } from "../../lib/constants";
import { GameStatusContext } from "../../providers/GameStatusProvider";

function SingleMistakeDisplay({ isUsed }) {
  return (
    <div
      className={`h-3 w-3 rounded-full ${
        isUsed ? "bg-transparent border border-[#5a594e]/40" : "bg-[#5a594e]"
      }`}
    />
  );
}

function NumberOfMistakesDisplay() {
  const { numMistakesUsed } = React.useContext(GameStatusContext);
  const mistakeRange = range(MAX_MISTAKES);
  return (
    <div className="flex flex-row gap-x-3 items-center justify-center">
      <p className="text-sm text-[#5a594e]">Mistakes remaining:</p>
      {mistakeRange.map((el) => (
        <SingleMistakeDisplay key={el} isUsed={el < numMistakesUsed} />
      ))}
    </div>
  );
}

export default NumberOfMistakesDisplay;
